import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = ({ toggleSidebar }) => {
    const [notifications, setNotifications] = useState(3);

    return (
        <header className="hidden lg:flex bg-white shadow-sm px-6 py-4 items-end justify-end border-b border-gray-200">
            <div className="flex items-center gap-6">
                <ul className="space-y-2">
                    <li>
                        <Link to="/profile" className="flex items-center p-1 sidebar-link">
                            <span className="material-icons text-3xl">account_circle</span> 
                        </Link>
                    </li>
                </ul>
            </div>
        </header>
    );
};

export default Header;
